import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
	matchesEvent,
	recordPerformedActionInCaches,
} from "web_myplann/Api/Portfolio/alertBoxesCacheUtils";
import {
	type AlertBoxActionEnum,
	type AlertBoxActionStateEnum,
	type PortfolioEventTypeEnum,
	postPortfolioIdAlertBoxesActionV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

type RecordActionVariables = {
	contractId: number;
	eventType: PortfolioEventTypeEnum;
	eventDate: string;
	action: AlertBoxActionEnum;
	state: AlertBoxActionStateEnum;
};

export const useRecordAlertBoxActionMutation = () => {
	const queryClient = useQueryClient();

	return useMutation<void, Error, RecordActionVariables>({
		mutationFn: processResponse(
			({
				contractId,
				eventType,
				eventDate,
				action,
				state,
			}: RecordActionVariables) =>
				postPortfolioIdAlertBoxesActionV2(
					{ eventType, eventDate, action, state },
					contractId,
				),
		),
		onSuccess: (_data, { contractId, eventType, eventDate, action, state }) => {
			recordPerformedActionInCaches(
				queryClient,
				contractId,
				matchesEvent(eventType, eventDate),
				action,
				state,
			);
		},
	});
};
